import {ProductSurface} from './ProductSurface';
import {ProductUnitary} from './ProductUnitary';
import { APP_URL } from 'js/common/AppUrl';

class Storage {
	constructor() {
		this.scene = null;
		this.equipment 	   	= new Map();
		this.entities 	   	= new Map();
		this.products 	   	= new Map();
		this.entityTypes   	= new Map();
		this.installPrices 	= new Map();
		this.dependenciesQuantities 	= new Map();
	}

	async fetch(sceneSlug) {
		this.scene = null;

		this.entities.clear();
		this.products.clear();
		this.entityTypes.clear();
		this.installPrices.clear();
		this.equipment.clear();

		if(typeof window.fetch == "undefined") return

		const response = await fetch(`${APP_URL}/storage/getscene/${sceneSlug}`)
		const data = await response.json()

		this.scene = Object.assign({}, data, {entities: null});

		data.entities.forEach((entity) => {
			this.entities.set(entity.code, entity)

			entity.products.forEach((product) => {
				product.entity = entity;
				this.products.set(product.code, product);
			});

			entity.dependencies.forEach(dependency => {
				if(!this.entities.has(dependency.code))
					this.entities.set(dependency.code, dependency);

				this.entityTypes.set(dependency.entity_type.code, dependency.entity_type);
				
				dependency.products.forEach(product => {
					product.entity = dependency;
					if(!this.products.has(product.code))
						this.products.set(product.code, product);
				})

				const key = `${entity.code}-${dependency.code}`;
				if(!this.dependenciesQuantities.has(key))
					this.dependenciesQuantities.set(key, 1);
				else this.dependenciesQuantities.set(key, this.dependenciesQuantities.get(key) + 1);
			});

			this.entityTypes.set(entity.entity_type.code, entity.entity_type);
			this.installPrices.set(entity.install_price.code, entity.install_price);
		});
		
		data.equipment.forEach(eqt => {
			this.equipment.set(eqt.slug, eqt);
		});

		// Fill collins face value
	}

	getEntityByCode(code) {
		return this.entities.get(code)
	}

	getProductByCode(code) {
		return this.products.get(code)
	}

	getEntityTypeByCode(code) {
		return this.entityTypes.get(code)
	}

	getInstallPriceByCode(code) {
		return this.installPrices.get(code)
	}

	getDependencyQuantity(entityCode, dependencyCode){
		const key = `${entity.code}-${dependency.code}`;
		if(this.dependenciesQuantities.has(key))
			return this.dependenciesQuantities.get(key);
		return 1;
	}

	getEntitiesByType(typecode, dependencyCode = null) {
		const entityType = this.getEntityTypeByCode(typecode)
		if(entityType == null) return [];
		const typeid = entityType.id
		if(typeid == null) return [];


		//Only select entities related to dependency if any
		let onlyIds = null;
		if(dependencyCode){
			const parentEntity = this.getEntityByCode(dependencyCode);
			onlyIds = parentEntity.dependenciesIds.map(dep => dep.dependency_id)
		}

		return [...this.entities].filter((value) => {
			return value[1].entity_type_id == typeid && (!onlyIds || onlyIds.includes(value[1].id))
		}).map((value) => value[1])
	}
}

const storage = new Storage();
export { storage };

window["storage"] = storage; // TODO

